/**
 * Jour courant à Paris, réactif.
 *
 * Installé en web app sur un téléphone, le tableau de bord n'est jamais
 * rechargé : ouvert le matin, repris le soir ou le lendemain, il garde le
 * même état React. Un `todayInParis()` lu une fois au rendu reste alors figé
 * sur le jour d'ouverture — « Aujourd'hui » montrerait la veille.
 *
 * On relit le jour au retour au premier plan et une fois par minute : la
 * valeur ne change qu'à minuit, et `useSyncExternalStore` ne re-rend que
 * quand elle change.
 */

import { useSyncExternalStore } from 'react';

import { todayInParis } from '../lib/dates';

function subscribe(onChange: () => void): () => void {
  const timer = window.setInterval(onChange, 60_000);
  document.addEventListener('visibilitychange', onChange);
  window.addEventListener('pageshow', onChange);
  return () => {
    window.clearInterval(timer);
    document.removeEventListener('visibilitychange', onChange);
    window.removeEventListener('pageshow', onChange);
  };
}

export function useParisDay(): string {
  return useSyncExternalStore(subscribe, todayInParis);
}
